import { render } from "./google-reviews.vue?vue&type=template&id=d8525dae&scoped=true"
import script from "./google-reviews.vue?vue&type=script&lang=js"
export * from "./google-reviews.vue?vue&type=script&lang=js"

import "./google-reviews.vue?vue&type=style&index=0&id=d8525dae&scoped=true&lang=css"

import exportComponent from "/Users/drewcarrette/Sites/connected-medical/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8525dae"]])

export default __exports__